import { humanizeDate } from "../../utils/formatters";

export const OPEN_FILE = 'OPEN_FILE';

function getProp( object, keys, defaultVal ){
  keys = Array.isArray( keys )? keys : keys.split('.');
  object = object[keys[0]];
  if( object && keys.length>1 ){
    return getProp( object, keys.slice(1), defaultVal );
  }
  return object === undefined? defaultVal : object;
}

export const columns = {
  'project': {
    name: 'Proyecto',
    path: 'project.name',
  },
  'name': {
    name: 'Nombre',
    path: 'name',
  },
  'description': {
    name: 'Descripción',
    path: 'description',
  },
  'created': {
    name: 'Fecha de creación',
    parse: (report) => {
      return humanizeDate(report.createdDate, true);
    }
  },
  'file': {
    name: 'Reporte',
    parse: (report) => {
      return report.filePath.split('/').pop();
    },
    config: {
        link: {
            action: OPEN_FILE
        },
    }
  }
};


export const parse = (items, columns) => {
  const columnValues = Object.values(columns);
  const columnNames = Object.keys(columns);

  return items.map((item) => {
    return columnValues.map((columnConfig, index) => {
      let value = '';
      if (columnConfig.parse) {
        value = columnConfig.parse(item);
      }
      else if (columnConfig.path) {
        value = getProp(item, columnConfig.path, '-');
      }
      else if (columnConfig.descriptions) {
        value = columnConfig.descriptions[item[columnNames[index]]];
      } else {
        value = item[columnNames[index]] || '-';
      }

      return {
        value,
        ...columnConfig.config && { config: columnConfig.config },
        item,
      }
    })
  })
}


